export class FansModel {
    fanName: string;
    fanId: string;
    email?: string;
    addpEligibility?: string;
    pdpIndicator?: string;
    marketPlaceBuy?: string;
    libertyIndicator?: string;
}